(function () {
  const root = document.querySelector('[data-vbf]');
  if (!root) return;

  const island = (root.closest('.shopify-section') || document).querySelector('script[id^="VbfData-"]');
  if (!island) return;
  const data = JSON.parse(island.textContent);
  const commerce = data.boards || {};
  const images = data.images || {};
  const subscriptions = data.subscriptions || {};
  const demoFrequencies = String(subscriptions.demoFrequencies || '').split(',').map((name) => name.trim()).filter(Boolean);
  const demoDiscount = Number(subscriptions.demoDiscount) || 0;

  /* family groups the boards a customer can switch between inside one fit result.
     Dedicated refills have no family, so their surface picker stays hidden. */
  const boards = {
    black: { id: 'black', family: '907', name: '907 Vector Board · Black', sku: '907-AM-1E', image: '907-black-800.webp', label: 'Black', pack: '12 sheets · up to 24 inserts', benefitTitle: 'Discreet in public spaces', benefit: 'The black surface keeps captured insects less visible from a distance.' },
    white: { id: 'white', family: '907', name: '907 Vector Board · White', sku: '907-W-AM-1E', image: '907-white-800.webp', label: 'White', pack: '12 sheets · up to 24 inserts', benefitTitle: 'Monitoring', benefit: 'The white surface allows professionals to easily monitor pest types.' },
    chartreuse: { id: 'chartreuse', family: '907', name: '907 Vector Board · Chartreuse', sku: '907-C-AM-1E', image: '907-yellow-800.webp', label: 'Chartreuse', pack: '12 sheets · up to 24 inserts', benefitTitle: 'Greenhouses / Farmers', benefit: 'A high-contrast surface for aphids, whiteflies, fungus gnats, thrips, leafminers, and leafhoppers.' },
    u909black: { id: 'u909black', family: '909', name: '909 Universal Board · Black', sku: '909-AM-1E', image: '909-black-800.webp', label: 'Black', pack: '12 sheets · up to 24 inserts', benefitTitle: 'Discreet in public spaces', benefit: 'The black surface keeps captured insects less visible from a distance.' },
    u909white: { id: 'u909white', family: '909', name: '909 Universal Board · White', sku: '909-W-AM-1E', image: '909-white-800.webp', label: 'White', pack: '12 sheets · up to 24 inserts', benefitTitle: 'Monitoring', benefit: 'The white surface allows professionals to easily monitor pest types.' },
    v9: { id: 'v9', name: 'Vector 9 Refill Boards', sku: '940-AM-RFL-12E', image: 'vector-9-refill-800.webp', label: 'Vector 9', pack: '12-pack' },
    pro: { id: 'pro', name: 'Pro Series Replacement Boards', sku: '925-AM-5E', image: 'pro-series-refill-800.webp', label: 'Pro Series', pack: '5-pack' }
  };

  Object.keys(boards).forEach((key) => {
    const board = boards[key];
    const live = commerce[key];
    board.variantId = live ? live.variantId : null;
    board.price = live ? live.price : null;
    board.available = Boolean(live && live.available && live.variantId);
    const plans = (live && live.plans) || [];
    // demo plans preview the discount on boards with no real plan; they never carry a selling plan id
    const demoPlans = subscriptions.demo ? demoFrequencies.map((name) => ({ id: null, name, price: Math.round(board.price * (100 - demoDiscount) / 100), group: null, demo: true })) : [];
    board.plans = typeof board.price !== 'number' ? [] : plans.length ? plans : demoPlans;
  });
  const savePct = (board, plan) => Math.round((1 - plan.price / board.price) * 100);

  // surfaces offered per family, in display order; 909 has no chartreuse
  const FAMILIES = { '907': ['black', 'white', 'chartreuse'], '909': ['u909black', 'u909white'] };
  const DEFAULT_BOARD = 'black';
  // variants are cosmetic only; `board` marks families with a dedicated refill
  const products = [
    { id: 'pone', name: 'Plasma One', meta: 'Compact', image: 'vector-plasma-one-angle-800.webp', front: 'vector-plasma-one-front-800.webp' },
    { id: 'pgs', name: 'Plasma Grilled/Screened', meta: 'Grilled or screened', image: 'vector-plasma-screened-angle-800.webp', front: 'vector-plasma-screened-front-800.webp', variants: [
      { id: 'pgrill', label: 'Grilled', name: 'Plasma Grilled', image: 'vector-plasma-grilled-angle-800.webp', front: 'vector-plasma-grilled-front-800.webp' },
      { id: 'pscreen', label: 'Screened', name: 'Plasma Screened', image: 'vector-plasma-screened-angle-800.webp', front: 'vector-plasma-screened-front-800.webp' }
    ] },
    { id: 'optima', name: 'Optima', meta: 'Black or white', image: 'optima-black-angle-800.webp', front: 'optima-black-front-800.webp', variants: [
      { id: 'optb', label: 'Black', name: 'Optima · Black', image: 'optima-black-angle-800.webp', front: 'optima-black-front-800.webp' },
      { id: 'optw', label: 'White', name: 'Optima · White', image: 'optima-white-angle-800.webp', front: 'optima-white-front-800.webp' }
    ] },
    { id: 'v15', name: 'Vector 15', meta: 'Silver', image: 'vector-15-angle-800.webp', front: 'vector-15-front-800.webp' },
    { id: 'v30', name: 'Vector 30', meta: 'Silver or black', image: 'vector-30-angle-800.webp', front: 'vector-30-front-800.webp', variants: [
      { id: 'v30s', label: 'Silver', name: 'Vector 30 · Silver', image: 'vector-30-angle-800.webp', front: 'vector-30-front-800.webp' },
      { id: 'v30b', label: 'Black', name: 'Vector 30 · Black', image: 'vector-30-black-angle-800.webp', front: 'vector-30-black-front-800.webp' }
    ] },
    { id: 'v9', name: 'Vector 9', meta: 'Plug-in trap', image: '940-am-1e-angle-800.webp', front: '940-am-1e-front-800.webp', board: 'v9' },
    { id: 'v911', name: 'Vector 911', meta: 'Pro Series', image: '911-am-1e-angle-800.webp', front: '911-am-1e-front-800.webp', board: 'pro' }
  ];
  // stand-in unit for the shared full-size refill and the board-guide shop buttons
  const SHARED = { id: 'shared', name: 'Full-size Vector', meta: 'Shared full-size refill', image: 'vector-30-angle-800.webp', front: 'vector-30-front-800.webp' };
  const state = { product: null, variant: null, board: DEFAULT_BOARD, purchase: 'once', plan: null, quantity: 1, entry: 'light' };
  const $ = (selector) => root.querySelector(selector);
  const $$ = (selector) => Array.from(root.querySelectorAll(selector));
  const finder = $('#finder') || root;
  const productView = $('#productView');
  const matchPanel = $('#matchPanel');
  const activeUnit = () => state.variant || state.product;

  const imageSet = (file) => images[file.replace(/-(480|800|1200|1600)\.webp$/, '')] || null;
  function imageUrl(file, width) {
    const set = imageSet(file);
    return set ? set[width] || null : null;
  }
  function setImage(el, url, alt) {
    if (!el) return;
    if (url) el.src = url;
    else el.removeAttribute('src');
    el.alt = alt;
  }
  function picture(file, alt) {
    const set = imageSet(file);
    if (!set) return '<picture></picture>';
    return `<picture><img src="${set['800']}" srcset="${set['480']} 480w, ${set['800']} 800w" sizes="(max-width: 699px) 34vw, 420px" width="800" height="600" alt="${alt}" loading="eager"></picture>`;
  }
  const money = (cents) => (typeof cents === 'number' ? `$${(cents / 100).toFixed(2)}` : '');

  // lets "Plasma Grilled/Screened" wrap after the slash on narrow tiles
  const breakAtSlash = (name) => name.replace(/\//g, '/<wbr>');
  function renderProducts() {
    const grid = $('#productGrid');
    $$('#productGrid [data-product]').forEach((node) => node.remove());
    grid.insertAdjacentHTML('afterbegin', products.map((prod) =>
      `<button class="fit-slot" type="button" data-product="${prod.id}" aria-label="Choose ${prod.name}">${picture(prod.image, prod.name)}<span><span class="fit-slot__label">${breakAtSlash(prod.name)}</span><span class="fit-slot__meta">${prod.meta}</span></span></button>`
    ).join(''));
    markActiveProduct();
  }
  function markActiveProduct() {
    $$('[data-product]').forEach((b) => b.setAttribute('aria-current', String(Boolean(state.product) && b.dataset.product === state.product.id)));
  }
  function animateIn(el) { el.classList.add('is-entering'); void el.offsetWidth; el.classList.remove('is-entering'); }
  function reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  // The theme header is sticky, so a scroll target at 0 would sit underneath it. --header-height
  // is not set on this theme, so the stuck header is measured directly.
  function headerOffset() {
    const header = document.querySelector('.shopify-section-header-sticky, .section-header');
    if (!header) return 0;
    const position = window.getComputedStyle(header).position;
    return position === 'sticky' || position === 'fixed' ? header.getBoundingClientRect().height : 0;
  }
  // In the fit result the masthead has done its job, so the panel itself is brought to the top
  // edge; that is what keeps Add to Cart on the first screen of a phone.
  function scrollToFinder(behavior) {
    const target = matchPanel.hidden ? root : matchPanel;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior });
  }
  function resetFinderViewport() {
    scrollToFinder('instant');
    // second pass catches layout settling as images decode, but never fights a user scroll
    let userScrolled = false;
    const cancel = () => { userScrolled = true; };
    ['wheel', 'touchstart', 'keydown'].forEach((t) => window.addEventListener(t, cancel, { once: true, passive: true }));
    setTimeout(() => {
      if (!userScrolled) scrollToFinder('instant');
      ['wheel', 'touchstart', 'keydown'].forEach((t) => window.removeEventListener(t, cancel));
      syncStickyBar();
    }, 260);
  }
  function showProducts() {
    const hadFocus = matchPanel.contains(document.activeElement);
    finder.classList.remove('is-deep');
    document.body.classList.remove('vbf-has-selection');
    matchPanel.hidden = true;
    productView.hidden = false;
    animateIn(productView);
    syncStickyBar();
    scrollToFinder(reduced() ? 'auto' : 'smooth');
    // hiding the panel drops keyboard focus to <body>; hand it back to the trap the shopper came from
    if (hadFocus) ($('[data-product][aria-current="true"]') || $('[data-product]')).focus({ preventScroll: true });
  }
  function selectProduct(productId) {
    const product = products.find((p) => p.id === productId);
    if (!product) return;
    state.product = product;
    state.variant = product.variants ? product.variants[0] : null;
    // explicit reset so a 909 board left by the cross-brand control never shows under a 907 trap
    state.board = product.board || DEFAULT_BOARD;
    if (state.purchase === 'subscribe' && !boards[state.board].plans.length) state.purchase = 'once';
    state.entry = 'light';
    markActiveProduct();
    showMatch();
  }
  function selectVariant(variantId) {
    const variant = (state.product.variants || []).find((v) => v.id === variantId);
    if (!variant) return;
    state.variant = variant;
    $('#selectedModel').textContent = variant.name;
    renderVariants();
    syncHeroImage();
  }
  function renderVariants() {
    const row = $('#variantRow');
    const variants = state.product.variants;
    row.hidden = !variants;
    if (!variants) { row.innerHTML = ''; return; }
    row.innerHTML = '<span class="variant-row__label">Which one do you have?</span>' + variants.map((v) =>
      `<button class="variant-chip" type="button" data-variant="${v.id}" aria-pressed="${Boolean(state.variant && state.variant.id === v.id)}">${v.label}</button>`
    ).join('');
  }
  function showSharedMatch() {
    state.product = SHARED;
    state.variant = null;
    // same reset as selectProduct, for the same leak
    state.board = DEFAULT_BOARD;
    if (state.purchase === 'subscribe' && !boards[state.board].plans.length) state.purchase = 'once';
    state.entry = 'light';
    markActiveProduct();
    showMatch();
  }
  function showMatch() {
    const dedicated = state.product.board;
    const hadFocus = productView.contains(document.activeElement);
    finder.classList.add('is-deep');
    document.body.classList.add('vbf-has-selection');
    productView.hidden = true;
    matchPanel.hidden = false;
    $('#selectedModel').textContent = activeUnit().name;
    syncHeroImage();
    $('#surfaceGroup').hidden = Boolean(dedicated);
    $('.reassurance').hidden = Boolean(dedicated);
    renderVariants();
    renderSurfaces();
    updatePurchase();
    animateIn(matchPanel);
    resetFinderViewport();
    syncStickyBar();
    // same focus drop as showProducts; preventScroll leaves the scroll to resetFinderViewport
    if (hadFocus) $('#matchPanel .match-title').focus({ preventScroll: true });
  }
  // the surface picker only offers boards inside the current family
  function currentFamily() { return (boards[state.board] || {}).family || null; }
  function renderSurfaces() {
    const family = currentFamily();
    // reset before the early return so a hidden fieldset never keeps announcing 909
    $('#surfaceLegend').textContent = family === '909' ? 'Choose surface · 909 Universal' : 'Choose surface';
    if (!family) { $('#surfaceOptions').innerHTML = ''; return; }
    $('#surfaceOptions').innerHTML = FAMILIES[family].map((id) => {
      const b = boards[id];
      return `<button class="surface-option" type="button" data-surface="${id}" aria-pressed="${state.board === id}"><span class="surface-swatch ${b.label.toLowerCase()}"></span><strong>${b.label}</strong><small>${b.benefitTitle === 'Discreet in public spaces' ? 'Discreet' : b.benefitTitle}</small></button>`;
    }).join('');
  }
  function selectedBoard() { return boards[state.board]; }
  // the chosen frequency follows the shopper across boards by name, else the board's first plan
  function selectedPlan(board) { return board.plans.find((p) => p.name === state.plan) || board.plans[0] || null; }
  function renderFrequencies(board, plan) {
    const group = $('#frequencyGroup');
    if (!group) return;
    group.hidden = !(plan && state.purchase === 'subscribe');
    const options = $('#frequencyOptions');
    options.replaceChildren(...board.plans.map((p, index) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'frequency-option';
      btn.dataset.frequency = String(index);
      btn.setAttribute('aria-pressed', String(p === plan));
      btn.textContent = p.name;
      return btn;
    }));
  }
  function syncHeroImage() {
    const hero = $('#matchedUnitImage');
    if (state.entry === 'board') {
      const board = selectedBoard();
      setImage(hero, imageUrl(board.image, '800'), board.name);
    } else {
      const unit = activeUnit();
      setImage(hero, imageUrl(unit.front || unit.image, '800'), unit.name);
    }
  }
  const isMonthly = (plan) => /\b1 month\b/i.test(plan.name);
  function updatePurchase() {
    const board = selectedBoard();
    const plan = selectedPlan(board);
    // switching surface can land on a board with no plan while subscribe is selected
    if (!plan && state.purchase === 'subscribe') state.purchase = 'once';
    // a one-option purchase row says nothing, so the whole row hides on a board with no plan
    $('.purchase-type').hidden = !plan;
    $('.subscribe-choice').hidden = !plan;
    if (plan) {
      $$('[data-vbf-save-label]').forEach((el) => {
        el.textContent = isMonthly(plan) ? `Save ${savePct(board, plan)}% monthly` : `Save ${savePct(board, plan)}%`;
      });
    }
    const sub = state.purchase === 'subscribe';
    renderFrequencies(board, plan);
    const demoNote = $('#demoNote');
    if (demoNote) demoNote.hidden = !(sub && plan.demo);
    const unit = sub ? plan.price : board.price;
    const total = typeof unit === 'number' ? unit * state.quantity : null;
    const family = currentFamily();
    $('#boardName').textContent = board.name.replace(/ · .*/, '');
    // the corner shape is how the two families are told apart in the hand
    $('#boardPack').textContent = board.pack + (family === '907' ? ' · Rounded corners' : family === '909' ? ' · Pointed corners' : '');
    // a dedicated refill has no universal equivalent, so the cross-brand switch hides there
    $('.cross-brand').hidden = !family;
    $('#crossBrandLabel').textContent = family === '909'
      ? 'Vector unit only? Back to the 907 Vector board.'
      : 'Need cross-brand fit? Switch to 909 Universal.';
    $('#price').textContent = money(unit);
    $('#quantity').textContent = state.quantity;
    setImage($('#selectedBoardImage'), imageUrl(board.image, '800'), board.name);
    if (state.entry === 'board') syncHeroImage();
    setImage($('#stickyBoardImage'), imageUrl(board.image, '480'), board.name);
    $('#stickyBoardName').textContent = board.name;
    $('#stickyPurchase').textContent = sub ? `${isMonthly(plan) ? 'Monthly' : plan.name} · Save ${savePct(board, plan)}%${plan.demo ? ' · Demo' : ''}` : 'One-time purchase';
    $('#stickyPrice').textContent = money(total);
    $$('[data-purchase]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.purchase === state.purchase)));
    $$('[data-surface]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.surface === state.board)));
    syncAddButtons();
    syncRepTriggers(board);
    // the frequency picker and demo note move the buy row
    syncStickyBar();
  }
  function syncRepTriggers(board) {
    const image = imageUrl(board.image, '480');
    $$('[data-sales-rep-trigger]').forEach((el) => {
      el.dataset.productTitle = board.name;
      if (image) el.dataset.productImage = image;
      else delete el.dataset.productImage;
    });
    if (window.CatchmasterSalesRep) window.CatchmasterSalesRep.enhance(root);
  }
  function shopBoard(boardId) {
    state.product = SHARED;
    state.variant = null;
    state.board = boardId;
    state.purchase = 'once';
    state.quantity = 1;
    state.entry = 'board';
    markActiveProduct();
    showMatch();
  }
  // swaps the board family in place, keeping the trap and the surface where it exists
  function toggleFamily() {
    const family = currentFamily();
    if (!family) return;
    const target = family === '907' ? '909' : '907';
    const here = FAMILIES[family].indexOf(state.board);
    state.board = FAMILIES[target][here] || FAMILIES[target][0];
    if (state.purchase === 'subscribe' && !boards[state.board].plans.length) state.purchase = 'once';
    renderSurfaces();
    updatePurchase();
    syncStickyBar();
  }
  function changeQuantity(delta) {
    state.quantity = Math.max(1, Math.min(12, state.quantity + delta));
    updatePurchase();
  }

  const addButtons = () => $$('[data-action="add"]');
  const addLabels = new WeakMap();
  function addLabel(btn) {
    if (!addLabels.has(btn)) addLabels.set(btn, btn.innerHTML);
    return addLabels.get(btn);
  }
  let adding = false;
  function syncAddButtons() {
    if (adding) return;
    const board = selectedBoard();
    const buyable = board.available;
    addButtons().forEach((btn) => {
      const label = addLabel(btn);
      btn.disabled = !buyable;
      if (buyable) btn.innerHTML = label;
      else btn.textContent = board.variantId ? 'Sold out' : 'Unavailable';
    });
  }

  function isUpCartActive() {
    return Boolean(document.body && document.body.hasAttribute('data-upcart-cart-enabled'));
  }
  function cartHost() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  function refreshCartBubble() {
    fetch(window.location.pathname + '?section_id=cart-icon-bubble')
      .then((r) => r.text())
      .then((html) => {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('.shopify-section') || doc.body;
        if (next) bubble.innerHTML = next.innerHTML;
      })
      .catch(() => {});
  }
  function openCart(result, host) {
    // the native drawer repaints the bubble itself when it renders sections
    let rendered = false;
    let opened = false;
    if (isUpCartActive()) {
      // UpCart owns the cart, so no cartUpdate publish here
      if (typeof window.upcartOpenCart === 'function') {
        try { window.upcartOpenCart(); opened = true; } catch (error) { /* UpCart not mounted yet */ }
      }
    } else if (host) {
      opened = true;
      try {
        host.classList.remove('is-empty');
        if (typeof host.renderContents === 'function' && result && result.sections) {
          host.renderContents(result);
          rendered = true;
        }
      } catch (error) { console.error(error); }
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'vector-board-finder',
            productVariantId: result && result.items && result.items[0] ? String(result.items[0].variant_id) : '',
            cartData: result
          });
        }
      } catch (error) { console.error(error); }
    }
    if (!rendered) refreshCartBubble();
    return opened;
  }
  async function addToCart(trigger) {
    const board = selectedBoard();
    if (adding || !board.available) return;
    adding = true;
    const buttons = addButtons();
    buttons.forEach((btn) => {
      addLabel(btn);
      btn.disabled = true;
      btn.textContent = 'Adding...';
    });

    const plan = state.purchase === 'subscribe' ? selectedPlan(board) : null;
    // a demo plan adds a one-time purchase until a subscription app supplies real plans
    const sellingPlan = plan && !plan.demo && plan.id ? plan.id : null;
    const payload = { items: [{ id: board.variantId, quantity: state.quantity, ...(sellingPlan ? { selling_plan: sellingPlan } : {}) }] };
    const host = isUpCartActive() ? null : cartHost();
    if (host && typeof host.getSectionsToRender === 'function') {
      try {
        payload.sections = host.getSectionsToRender().map((s) => s.id);
        payload.sections_url = window.location.pathname;
        if (typeof host.setActiveElement === 'function') host.setActiveElement(trigger);
      } catch (error) { /* sections are an enhancement */ }
    }

    let message = 'Added';
    let delay = 1600;
    try {
      const response = await fetch(data.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await response.json().catch(() => null);
      if (!response.ok || (result && result.status)) {
        const shopifyMessage = result && (result.description || result.message);
        const error = new Error(shopifyMessage || `Cart add failed (${response.status})`);
        error.shoppable = Boolean(shopifyMessage);
        throw error;
      }
      // with no drawer mounted (the live default) the PDP goes to /cart too
      if (!openCart(result, host)) window.location.href = data.cartUrl;
    } catch (error) {
      console.error('Vector board finder: add to cart failed', error);
      message = error && error.shoppable ? error.message : 'Could not add, try again';
      delay = 3000;
    }

    buttons.forEach((btn) => {
      if (btn === trigger) btn.textContent = message;
      else btn.innerHTML = addLabel(btn);
    });
    setTimeout(() => {
      adding = false;
      syncAddButtons();
    }, delay);
  }

  // the sticky bar backs up the in-panel buy row once that row has scrolled above the viewport,
  // or while it still sits below the first screen on a short phone
  const buyRow = $('.buy-row');
  function syncStickyBar() {
    const row = buyRow.getBoundingClientRect();
    const ready = !matchPanel.hidden && row.height > 0;
    document.body.classList.toggle('vbf-show-sticky', ready && (row.bottom <= headerOffset() || row.bottom > window.innerHeight));
  }

  function initSubscribeBand() {
    const all = Object.keys(boards).flatMap((key) => boards[key].plans.map((plan) => savePct(boards[key], plan)));
    const best = Math.max(0, ...all);
    $$('[data-vbf-save-pct]').forEach((el) => { el.textContent = `${best}%`; });
    $$('[data-vbf-subscribe-band], [data-vbf-subscribe-panel], [data-vbf-subscribe-copy]').forEach((el) => { el.hidden = !all.length; });
  }

  root.addEventListener('click', (event) => {
    const product = event.target.closest('[data-product]');
    if (product) { selectProduct(product.dataset.product); return; }
    const variant = event.target.closest('[data-variant]');
    if (variant) { selectVariant(variant.dataset.variant); return; }
    const surface = event.target.closest('[data-surface]');
    if (surface) { state.board = surface.dataset.surface; renderSurfaces(); updatePurchase(); return; }
    const shop = event.target.closest('[data-shop-board]');
    if (shop) { shopBoard(shop.dataset.shopBoard); return; }
    const purchase = event.target.closest('[data-purchase]');
    if (purchase) { state.purchase = purchase.dataset.purchase; updatePurchase(); return; }
    const frequency = event.target.closest('[data-frequency]');
    if (frequency) {
      const plan = selectedBoard().plans[Number(frequency.dataset.frequency)];
      if (plan) state.plan = plan.name;
      updatePurchase();
      return;
    }
    const quantity = event.target.closest('[data-quantity]');
    if (quantity) { changeQuantity(Number(quantity.dataset.quantity)); return; }
    const action = event.target.closest('[data-action]');
    if (!action) return;
    if (action.dataset.action === 'products') showProducts();
    if (action.dataset.action === 'shared-refill') showSharedMatch();
    if (action.dataset.action === 'cross-brand') toggleFamily();
    if (action.dataset.action === 'add') addToCart(action);
  });

  // IntersectionObserver is primary because iOS Safari suppresses scroll events during
  // momentum scrolling; scroll and resize stay as a fallback for layout changes
  // 1 as well, so the bar hands back once the whole row scrolls into view from below
  new IntersectionObserver(syncStickyBar, { threshold: [0, 1] }).observe(buyRow);
  window.addEventListener('scroll', syncStickyBar, { passive: true });
  window.addEventListener('resize', syncStickyBar, { passive: true });
  window.addEventListener('orientationchange', syncStickyBar);

  addButtons().forEach(addLabel);
  syncAddButtons();
  initSubscribeBand();
  syncStickyBar();
  renderProducts();
  syncRepTriggers(selectedBoard());
})();
